class ProductMediaCarousel {
  constructor() {
    this.carousels = new Map();
    this.currentSlide = new Map();
    this.slideCount = new Map();
    this.init();
  }

  init() {
    console.log('ProductMediaCarousel: init() called');
    const carouselElements = document.querySelectorAll('[data-media-gallery]');
    console.log('ProductMediaCarousel: Found carousel elements:', carouselElements.length);
    
    carouselElements.forEach((carouselElement) => {
      const galleryId = carouselElement.getAttribute('data-gallery-id');
      console.log('ProductMediaCarousel: Processing gallery ID:', galleryId);
      
      if (this.carousels.has(galleryId)) {
        console.log('ProductMediaCarousel: Gallery already initialized:', galleryId);
        return; // Already initialized
      }

      this.carousels.set(galleryId, carouselElement);
      this.setupCarousel(galleryId);
    });
  }

  setupCarousel(galleryId) {
    console.log('ProductMediaCarousel: setupCarousel() called for:', galleryId);
    const carousel = this.carousels.get(galleryId);
    if (!carousel) {
      console.log('ProductMediaCarousel: No carousel found for ID:', galleryId);
      return;
    }

    const track = carousel.querySelector('[data-carousel-track]');
    const slides = carousel.querySelectorAll('.carousel-slide');
    const dots = carousel.querySelectorAll('.carousel-dot');
    const prevBtns = carousel.querySelectorAll('[data-carousel-prev]');
    const nextBtns = carousel.querySelectorAll('[data-carousel-next]');
    const mediaCounter = carousel.querySelector('[data-current-index]');
    const uploadInput = carousel.querySelector('input[type="file"]');

    console.log('ProductMediaCarousel: Elements found:', {
      track: !!track,
      slides: slides.length,
      dots: dots.length,
      prevBtns: prevBtns.length > 0,
      nextBtns: nextBtns.length > 0,
      mediaCounter: !!mediaCounter,
      uploadInput: !!uploadInput
    });

    if (!track || slides.length === 0) {
      console.log('ProductMediaCarousel: Track or slides missing');
      return;
    }

    // Store carousel data
    const slideCount = slides.length;
    this.slideCount.set(galleryId, slideCount);
    this.currentSlide.set(galleryId, 0);
    console.log('ProductMediaCarousel: Initialized with', slideCount, 'slides');

    if (prevBtns.length > 0) {
      prevBtns.forEach(btn => btn.addEventListener('click', (e) => {
        e.preventDefault();
        this.previousSlide(galleryId);
      }));
    }

    if (nextBtns.length > 0) {
      nextBtns.forEach(btn => btn.addEventListener('click', (e) => {
        e.preventDefault();
        this.nextSlide(galleryId);
      }));
    }

    // Set up dots navigation
    dots.forEach((dot, index) => {
      dot.addEventListener('click', (e) => {
        e.preventDefault();
        this.goToSlide(galleryId, index);
      });

      // Keyboard accessibility for dots
      dot.addEventListener('keydown', (e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          this.goToSlide(galleryId, index);
        }
      });
    });

    // Keyboard navigation for the carousel
    carousel.addEventListener('keydown', (e) => {
      this.handleKeyboardNavigation(galleryId, e);
    });

    // Touch/swipe support
    this.setupTouchNavigation(galleryId, track);

    // Handle image upload
    if (uploadInput) {
      uploadInput.addEventListener('change', (e) => {
        this.handleImageUpload(galleryId, e);
      });
    }

    // Auto-advance carousel (optional)
    if (carousel.dataset.autoplay) {
      this.setupAutoplay(galleryId, parseInt(carousel.dataset.autoplayDelay) || 5000);
    }

    // Initialize first slide
    this.updateCarousel(galleryId);
  }

  goToSlide(galleryId, slideIndex) {
    const carousel = this.carousels.get(galleryId);
    const slideCount = this.slideCount.get(galleryId);
    
    if (!carousel || slideIndex < 0 || slideIndex >= slideCount) return;

    this.currentSlide.set(galleryId, slideIndex);
    this.updateCarousel(galleryId);
  }

  nextSlide(galleryId) {
    const currentIndex = this.currentSlide.get(galleryId);
    const slideCount = this.slideCount.get(galleryId);
    const nextIndex = (currentIndex + 1) % slideCount;
    this.goToSlide(galleryId, nextIndex);
  }

  previousSlide(galleryId) {
    const currentIndex = this.currentSlide.get(galleryId);
    const slideCount = this.slideCount.get(galleryId);
    const prevIndex = (currentIndex - 1 + slideCount) % slideCount;
    this.goToSlide(galleryId, prevIndex);
  }

  updateCarousel(galleryId) {
    const carousel = this.carousels.get(galleryId);
    const currentIndex = this.currentSlide.get(galleryId);
    
    if (!carousel) return;

    const track = carousel.querySelector('[data-carousel-track]');
    const dots = carousel.querySelectorAll('.carousel-dot');
    const mediaCounter = carousel.querySelector('[data-current-index]');
    const mediaTitle = carousel.querySelector('[data-media-title]');
    const slides = carousel.querySelectorAll('.carousel-slide');

    // Update track position
    if (track) {
      const translateX = -currentIndex * (100 / this.slideCount.get(galleryId));
      track.style.transform = `translateX(${translateX}%)`;
    }

    // Update dots
    dots.forEach((dot, index) => {
      dot.classList.toggle('active', index === currentIndex);
    });

    // Update counter
    if (mediaCounter) {
      mediaCounter.textContent = (currentIndex + 1).toString() + ' / ' + this.slideCount.get(galleryId);
    }

    // Update media title if available
    if (mediaTitle && slides[currentIndex]) {
      const currentSlide = slides[currentIndex];
      const img = currentSlide.querySelector('img');
      if (img && img.alt) {
        mediaTitle.textContent = img.alt;
      }
    }

    // Pause all videos except current one
    slides.forEach((slide, index) => {
      const video = slide.querySelector('video');
      if (video) {
        if (index === currentIndex) {
          // Play the video and catch any browser autoplay promise rejections
          const playPromise = video.play();
          if (playPromise !== undefined) {
            playPromise.catch(error => {
              console.log('Autoplay was prevented by browser:', error);
            });
          }
        } else {
          video.pause();
        }
      }
    });
  }

  setupTouchNavigation(galleryId, track) {
    let startX = 0;
    let currentX = 0;
    let isDragging = false;

    const handleStart = (e) => {
      isDragging = true;
      startX = e.type === 'mousedown' ? e.clientX : e.touches[0].clientX;
      track.style.cursor = 'grabbing';
    };

    const handleMove = (e) => {
      if (!isDragging) return;
      e.preventDefault();
      currentX = e.type === 'mousemove' ? e.clientX : e.touches[0].clientX;
    };

    const handleEnd = () => {
      if (!isDragging) return;
      isDragging = false;
      track.style.cursor = 'grab';

      const diffX = startX - currentX;
      const threshold = 50;

      if (Math.abs(diffX) > threshold) {
        if (diffX > 0) {
          this.nextSlide(galleryId);
        } else {
          this.previousSlide(galleryId);
        }
      }
    };

    // Mouse events
    track.addEventListener('mousedown', handleStart);
    document.addEventListener('mousemove', handleMove);
    document.addEventListener('mouseup', handleEnd);

    // Touch events
    track.addEventListener('touchstart', handleStart, { passive: true });
    track.addEventListener('touchmove', handleMove, { passive: false });
    track.addEventListener('touchend', handleEnd);
  }

  handleKeyboardNavigation(galleryId, event) {
    switch (event.key) {
      case 'ArrowLeft':
        event.preventDefault();
        this.previousSlide(galleryId);
        break;
      case 'ArrowRight':
        event.preventDefault();
        this.nextSlide(galleryId);
        break;
      case 'Home':
        event.preventDefault();
        this.goToSlide(galleryId, 0);
        break;
      case 'End':
        event.preventDefault();
        this.goToSlide(galleryId, this.slideCount.get(galleryId) - 1);
        break;
    }
  }

  handleImageUpload(galleryId, event) {
    const files = event.target.files;
    if (!files || files.length === 0) return;

    // Create preview of uploaded images
    Array.from(files).forEach(file => {
      if (file.type.startsWith('image/')) {
        const reader = new FileReader();
        reader.onload = (e) => {
          this.addUploadedImage(galleryId, e.target.result, file.name);
        };
        reader.readAsDataURL(file);
      }
    });
  }

  addUploadedImage(galleryId, imageSrc, fileName) {
    const carousel = this.carousels.get(galleryId);
    if (!carousel) return;

    const track = carousel.querySelector('[data-carousel-track]');
    const dotsContainer = carousel.querySelector('[data-carousel-dots]');
    
    if (!track) return;

    // Create new slide
    const newSlide = document.createElement('div');
    newSlide.className = 'carousel-slide';
    newSlide.innerHTML = `
      <img src="${imageSrc}" alt="${fileName}" loading="lazy" style="object-fit: cover;">
      <div class="media-type-badge">Uploaded</div>
    `;

    track.appendChild(newSlide);

    // Create new dot
    if (dotsContainer) {
      const newDot = document.createElement('button');
      newDot.className = 'carousel-dot';
      newDot.setAttribute('data-dot-index', this.slideCount.get(galleryId));
      newDot.setAttribute('aria-label', `Go to slide ${this.slideCount.get(galleryId) + 1}`);
      
      newDot.addEventListener('click', (e) => {
        e.preventDefault();
        this.goToSlide(galleryId, parseInt(newDot.getAttribute('data-dot-index')));
      });

      dotsContainer.appendChild(newDot);
    }

    // Update slide count and track width
    const newSlideCount = this.slideCount.get(galleryId) + 1;
    this.slideCount.set(galleryId, newSlideCount);
    track.style.width = `${newSlideCount * 100}%`;

    // Update all slide flex-basis
    const slides = track.querySelectorAll('.carousel-slide');
    slides.forEach(slide => {
      slide.style.flexBasis = `${100 / newSlideCount}%`;
    });

    // Go to the new slide
    this.goToSlide(galleryId, newSlideCount - 1);
  }

  setupAutoplay(galleryId, delay) {
    const intervalId = setInterval(() => {
      const carousel = this.carousels.get(galleryId);
      if (!carousel || !document.contains(carousel)) {
        clearInterval(intervalId);
        return;
      }

      // Pause autoplay if user is hovering
      if (carousel.matches(':hover')) return;

      this.nextSlide(galleryId);
    }, delay);

    // Store interval ID for cleanup
    this.carousels.get(galleryId).autoplayInterval = intervalId;
  }

  // Public API methods
  getCurrentSlide(galleryId) {
    return this.currentSlide.get(galleryId);
  }

  getTotalSlides(galleryId) {
    return this.slideCount.get(galleryId);
  }

  // Clean up event listeners
  destroy() {
    this.carousels.forEach((carousel, galleryId) => {
      // Clear autoplay intervals
      if (carousel.autoplayInterval) {
        clearInterval(carousel.autoplayInterval);
      }

      // Remove event listeners
      const prevBtn = carousel.querySelector('[data-carousel-prev]');
      const nextBtn = carousel.querySelector('[data-carousel-next]');
      const dots = carousel.querySelectorAll('.carousel-dot');

      if (prevBtn) prevBtn.removeEventListener('click', this.previousSlide);
      if (nextBtn) nextBtn.removeEventListener('click', this.nextSlide);
      
      dots.forEach(dot => {
        dot.removeEventListener('click', this.goToSlide);
        dot.removeEventListener('keydown', this.handleKeyboardNavigation);
      });

      carousel.removeEventListener('keydown', this.handleKeyboardNavigation);
    });
    
    this.carousels.clear();
    this.currentSlide.clear();
    this.slideCount.clear();
  }
}

// Initialize carousel when DOM is ready
document.addEventListener('DOMContentLoaded', function() {
  console.log('Product Media Carousel: DOM Content Loaded');
  window.productMediaCarousel = new ProductMediaCarousel();
  console.log('Product Media Carousel: Initialized', window.productMediaCarousel);
});

// Reinitialize on dynamic content changes
document.addEventListener('shopify:section:load', function() {
  console.log('Product Media Carousel: Section Load Event');
  if (window.productMediaCarousel) {
    window.productMediaCarousel.init();
  }
});

// Handle theme editor section reloads
document.addEventListener('shopify:section:unload', function() {
  console.log('Product Media Carousel: Section Unload Event');
  if (window.productMediaCarousel) {
    window.productMediaCarousel.destroy();
  }
});

document.addEventListener('shopify:section:select', function() {
  console.log('Product Media Carousel: Section Select Event');
  if (window.productMediaCarousel) {
    window.productMediaCarousel.init();
  }
});

// Export for external use
if (typeof module !== 'undefined' && module.exports) {
  module.exports = ProductMediaCarousel;
} 